import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

function Assign({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.ARRAY.';

    return (
        <div>
            <div className="form-element">
                {t(label + 'ARRAY-VARIABLE')}
                <TextInput action={action} inputName="set" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired include={['array']} fieldType="array" displayName={t(label + 'ARRAY-VARIABLE')}  />
            </div>
            <div className="form-element">
                {t(label + 'VARIABLE')}
                <TextInput action={action} inputName="item" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired multiline={4} defaultValue="[]" fieldType="array" displayName={t(label + 'VARIABLE')}/>
                <small><em>e.g. ["test","autommate"] or ##arr## or [5,4,3]</em></small>
            </div>
        </div>
    );
}

export default Assign;
